import React, { forwardRef } from 'react';
import classNames from 'classnames';

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size' | 'prefix'> {
  size?: 'sm' | 'md' | 'lg';
  invalid?: boolean;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      size = 'md',
      invalid = false,
      disabled = false,
      prefix,
      suffix,
      type = 'text',
      ...rest
    },
    ref
  ) => {
    const sizeClasses = {
      sm: 'ecme-input-sm',
      md: 'ecme-input-md',
      lg: 'ecme-input-lg',
    };

    const inputClasses = classNames(
      'ecme-input',
      sizeClasses[size],
      {
        'ecme-input-invalid': invalid,
        'ecme-input-disabled': disabled,
        'ps-10': prefix,
        'pe-10': suffix,
      },
      className
    );

    if (prefix || suffix) {
      return (
        <div className="ecme-input-wrapper">
          {prefix && <div className="ecme-input-prefix">{prefix}</div>}
          <input
            ref={ref}
            type={type}
            className={inputClasses}
            disabled={disabled}
            {...rest}
          />
          {suffix && <div className="ecme-input-suffix">{suffix}</div>}
        </div>
      );
    }

    return (
      <input
        ref={ref}
        type={type}
        className={inputClasses}
        disabled={disabled}
        {...rest}
      />
    );
  }
);

Input.displayName = 'Input';

export default Input;
